import {Box, ButtonGroup} from '@mui/material'

import {StyledZoomButton, StyledZoomResetButton} from '../TimeSeriesDashboardStyle'
import {ZoomIn, ZoomOut} from '@mui/icons-material'
import PropTypes from 'prop-types'

import MarkerMenu from './MarkerMenu'

export const ChartActionButtons = ({displayLegend, zoomProps, chartRef, setClickAwayEnabled}) => {
  return (
    <Box display={'flex'} columnGap={'10px'} height={'fit-content'} sx={{justifyContent: 'flex-end'}}>
      <MarkerMenu chartRef={chartRef} displayLegend={displayLegend} setClickAwayEnabled={setClickAwayEnabled} />
      <StyledZoomResetButton
        disabled={!displayLegend || (zoomProps.reset && displayLegend)}
        onClick={zoomProps.handleResetZoom}
        data-testid='zoom-reset'
        aria-label='zoom-reset'
      >
        Reset Zoom
      </StyledZoomResetButton>

      <ButtonGroup disabled={!displayLegend} variant='outlined' size='small' aria-label='Zoom buttons '>
        <StyledZoomButton
          variant='outlined'
          disabled={!displayLegend || (zoomProps.out && displayLegend)}
          onClick={zoomProps.handleZoomOut}
          aria-label='zoom-out'
          data-testid='zoom-out'
        >
          <ZoomOut />
        </StyledZoomButton>
        <StyledZoomButton
          variant='outlined'
          disabled={!displayLegend || (zoomProps.in && displayLegend)}
          onClick={zoomProps.handleZoomIn}
          data-testid='zoom-in'
          aria-label='zoom-in'
        >
          <ZoomIn />
        </StyledZoomButton>
      </ButtonGroup>
    </Box>
  )
}

ChartActionButtons.propTypes = {
  displayLegend: PropTypes.bool,
  zoomProps: PropTypes.shape({
    reset: PropTypes.bool,
    out: PropTypes.bool,
    in: PropTypes.bool,
    handleResetZoom: PropTypes.func,
    handleZoomIn: PropTypes.func,
    handleZoomOut: PropTypes.func
  }),
  chartRef: PropTypes.object,
  setClickAwayEnabled: PropTypes.func
}
